import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'COMISSAO_TIPO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'COMISSAO_TIPO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('comissaoTipoForm', registro)
    ];
}

export function getLista() {
	return (dispatch, getState) => {
		dispatch(setAguardando(true));
    	axios.get(`${consts.API_URL}/comissaoTipo`)
		.then(resp => {
			dispatch({
		        type: 'COMISSAO_TIPO_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/comissaoTipo`, {
				...registro,
				conquista_integral: FormatUtils.formatarValorBanco(registro.conquista_integral, 3),
				conquista_30_60: FormatUtils.formatarValorBanco(registro.conquista_30_60, 3),
				conquista_mais_60: FormatUtils.formatarValorBanco(registro.conquista_mais_60, 3),
				manutencao_integral: FormatUtils.formatarValorBanco(registro.manutencao_integral, 3),
				manutencao_30_60: FormatUtils.formatarValorBanco(registro.manutencao_30_60, 3),
				manutencao_mais_60: FormatUtils.formatarValorBanco(registro.manutencao_mais_60, 3),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/comissaoTipo`, {
				...registro,
				conquista_integral: FormatUtils.formatarValorBanco(registro.conquista_integral, 3),
				conquista_30_60: FormatUtils.formatarValorBanco(registro.conquista_30_60, 3),
				conquista_mais_60: FormatUtils.formatarValorBanco(registro.conquista_mais_60, 3),
				manutencao_integral: FormatUtils.formatarValorBanco(registro.manutencao_integral, 3),
				manutencao_30_60: FormatUtils.formatarValorBanco(registro.manutencao_30_60, 3),
				manutencao_mais_60: FormatUtils.formatarValorBanco(registro.manutencao_mais_60, 3),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/comissaoTipo?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}
